import { render, staticRenderFns } from "./DoctrineCard.vue?vue&type=template&id=496038e6&"
import script from "./DoctrineCard.vue?vue&type=script&lang=js&"
export * from "./DoctrineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports